import columns from "../configs/clients-table-config";

const getClientsTableColumns = () => {
  return columns;
}

export default getClientsTableColumns;